import { Component } from '@angular/core'
import { trigger, transition, animate, style, state } from '@angular/animations';

@Component({
    selector: 'app-display-box',
    animations: [
        trigger('displayBox', [
            state('closed', style({height: "0px"})),
            state('open', style({height: '*'})),
            transition('open => closed', [animate('0.5s')]),
            transition('closed => open', [animate('0.5s')]),
        ]),
    ],
    templateUrl: './display-box.component.html',
    styleUrls: ['./display-box.component.scss'],
})
export class DisplayBoxComponent {
    constructor() {}
    
    isOpen = false;

    toggle() {
        this.isOpen = !this.isOpen;
    }
}